import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from 'src/common/top-nav/TopNav';
import './AdvanceSearch.less';

export default class AdvanceSearch extends OfficialPage {
  state = {
    history: [],
    inputContent: ''
  }

  constructor(props) {
    super(props);
    document.title = '搜索';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      form: options.form || '',
      comeSearch: options.search ? true : false,
      inputContent: options.search || '',
      isHideStock: options.isHideStock || '',
      isHideSales: options.isHideSales || '',
      integral: options.integral || '',
      isShowVirtualPrice: options.isShowVirtualPrice || '',
      isShoppingCart: options.isShoppingCart || '',
      isBuyNow: options.isBuyNow || '',
      category: options.category || '',
      isShowFG: options.isShowFG || ''
    })
    var _this = this
    app.getStorage({
      key: 'history',
      success: function(res) {
        _this.setData({ history: res.data || [] })
      }
    })
  }

  searchList = () => {
    let history = this.data.history
    let content = this.data.inputContent
    let index = history.indexOf(content)
    if (index > -1) {
      history.splice(index, 1)
    }
    history.unshift(content)
    this.setData({ history: history })
    app.setStorage({
      key: 'history',
      data: history
    })
    if (this.data.comeSearch) {
      app.setStorage({
        key: 'current-search',
        data: content
      })
      app.turnBack()
      app.globalData.classifyGoodsListPageRefresh = true
    } else {
      this.turnToClassifyGoodsListPage(content)
    }
  }
  quickSearch = e => {
    let tag = e.target.dataset.tag
    this.setData({ inputContent: tag })
    if (this.data.comeSearch) {
      app.setStorage({
        key: 'current-search',
        data: tag
      })
      app.turnBack()
      app.globalData.classifyGoodsListPageRefresh = true
    } else {
      this.turnToClassifyGoodsListPage(tag)
    }
  }
  turnToClassifyGoodsListPage = word => {
    let data = this.data
    let param = ''
    if (data.isHideStock != '') {
      param += '&isHideStock=' + data.isHideStock
    }
    if (data.isHideSales != '') {
      param += '&isHideSales=' + data.isHideSales
    }
    if (data.integral != '') {
      param += '&integral=' + data.integral
    }
    if (data.isShowVirtualPrice != '') {
      param += '&isShowVirtualPrice=' + data.isShowVirtualPrice
    }
    if (data.isShoppingCart != '') {
      param += '&isShoppingCart=' + data.isShoppingCart
    }
    if (data.isBuyNow != '') {
      param += '&isBuyNow=' + data.isBuyNow
    }
    if (data.category != '') {
      param += '&category_id=' + data.category
    }
    if (+data.isShowFG === 1) {
      param += '&isShowFG=' + 1
    }
    app.turnToPage(
      '/pages/classifyGoodsListPage/classifyGoodsListPage?form=' +
      data.form +
      '&search=' +
      word +
      param,
      true
    )
  }
  bindChange = e => {
    let _value = e.target.value;
    this.setData({ inputContent: _value });
  }
  clearSearch = () => {
    this.setData({
      inputContent: '',
      showResult: false
    })
  }
  clearHistory = () => {
    let _this = this
    app.removeStorage({
      key: 'history',
      success: function(res) {
        _this.setData({ history: [] })
      }
    })
  }
  navigateBack = () => {
    app.turnBack()
  }

  render() {
    const { inputContent, history } = this.state
    return (
      <div className="official-page advance-search">
        <TopNav title="搜索" />
        <div className="comp-search">
          <div
            className="ico-moon icon-location locate hide"
            onClick={this.filterByLocation}
          >
            全国
          </div>
          <div className="search-wrap">
            <span size="14" type="search" onClick={this.searchList}></span>
            <input
              id="search"
              value={inputContent}
              onInput={this.bindChange}
              onBlur={this.searchList}
              // focus="true"
              name="input"
              placeholder="请输入搜索关键词"
              // confirmType="search"
            />
            <div
              className={'cross ' + (inputContent == '' ? 'hide' : '')}
              onClick={this.clearSearch}
            >×</div>
          </div>
          <button className="cancel" onClick={this.navigateBack}>
            取消
          </button>
        </div>
        <div className="history">
          <div className="title">
            <span className="left">历史搜索</span>
            <span className="right" onClick={this.clearHistory}>
              清除
            </span>
          </div>
          <div className="content">
            {history && history.map((item, index) => {
              return (
                <div
                  className="history-item"
                  key
                  data-tag={item}
                  onClick={this.quickSearch}
                >
                  {item}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/advance-search/AdvanceSearch.jsx